import PropTypes from 'prop-types'
import {styled} from '@mui/material/styles'
import Box from '@mui/material/Box'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import Typography from '@mui/material/Typography'
import {Button} from '@mui/material'

const PREFIX = 'ChartDataRefetchOnErrorTrend'

const classes = {
  icon: `${PREFIX}-icon`,
  loadDataBoxAction: `${PREFIX}-loadDataBoxAction`,
  tryAgainText: `${PREFIX}-tryAgainText`,
  tryAgainButton: `${PREFIX}-tryAgainBtn`
}

const StyledBox = styled(Box)(({theme}) => ({
  padding: theme.spacing(10),
  height: '300px',
  [`& .${classes.icon}`]: {
    color: theme.palette.hpAccentRed,
    width: '1em',
    height: '1em'
  },

  [`& .${classes.loadDataBoxAction}`]: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.hpAccentBlack,
    display: 'flex'
  },
  [`& .${classes.tryAgainButton}`]: {
    border: 'none',
    backgroundColor: 'transparent',
    padding: 0,
    textTransform: 'none',
    ':hover': {
      backgroundColor: 'transparent',
      border: 'none'
    }
  },
  [`& .${classes.tryAgainText}`]: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.hpPrimary,
    paddingLeft: '5px',
    textDecoration: 'underline',
    ':hover': {
      cursor: 'pointer'
    }
  },
  [theme.breakpoints.up('xl')]: {
    height: '400px'
  },
  [theme.breakpoints.between('xs', 'sm')]: {
    height: '500px'
  }
}))

function ChartDataRefetchOnError({onTryAgain}) {
  return (
    <StyledBox
      data-testid='timeseries-data-refetch-on-error'
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
    >
      <ErrorOutlineIcon className={classes.icon} />
      <Typography
        variant='h6'
        tabIndex={0}
        aria-label='Visualization failed to load.'
        className={classes.loadDataBoxAction}
      >
        Visualization failed to load.
        <Button
          className={classes.tryAgainButton}
          aria-label='Try again to fetch the details'
          onClick={onTryAgain}
          onKeyDown={onTryAgain}
          tabIndex={0}
        >
          <Typography variant='h6' className={classes.tryAgainText}>
            Try again
          </Typography>
        </Button>
      </Typography>
    </StyledBox>
  )
}

ChartDataRefetchOnError.propTypes = {
  onTryAgain: PropTypes.func
}
export default ChartDataRefetchOnError
